function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Drawer, Button, Divider, message } from "antd";
import UserLogin from "../components/forms/UserLogin";
import UserRegister from "../components/forms/UserRegister";
import MobileConfirmForm from "../components/forms/MobileConfirmForm";
import { Container, Row, Col } from 'react-bootstrap';
import InitPasswordReset from "./forms/InitPasswordReset";
import { useParams } from 'react-router-dom';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var UserConnectDrawer = function UserConnectDrawer(_ref) {
  var display = _ref.display,
    hideDrawer = _ref.hideDrawer;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    drawerVisible = _useState2[0],
    setDrawerVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    childrenDraweVisible = _useState4[0],
    setChildrenDrawerVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    initDrawerVisible = _useState6[0],
    setInitDrawerVisible = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    newMobile = _useState8[0],
    setNewMobile = _useState8[1];
  var _useParams = useParams(),
    dl = _useParams.dl;
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    newFn = _useState10[0],
    setNewFn = _useState10[1];
  var onDrawerClose = function onDrawerClose() {
    setDrawerVisible(false);
    hideDrawer();
  };
  var showChildrenDrawer = function showChildrenDrawer() {
    setChildrenDrawerVisible(true);
  };
  var onChildrenDrawerClose = function onChildrenDrawerClose() {
    setChildrenDrawerVisible(false);
  };
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    registered = _useState12[0],
    setRegistered = _useState12[1];
  var handleRegister = function handleRegister(mob, fn) {
    setRegistered(true);
    setNewMobile(mob);
    setNewFn(fn);
  };
  useEffect(function () {
    if (display == true) {
      setDrawerVisible(display);
    }
  });
  useEffect(function () {
    if (dl == 'ok') setDrawerVisible(true);
  }, [dl]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Drawer, {
      title: "Se connecter",
      width: "99%",
      closable: true,
      onClose: onDrawerClose,
      visible: drawerVisible,
      children: [/*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            lg: 4,
            md: 5,
            sm: 12,
            children: [/*#__PURE__*/_jsx(UserLogin, {}), /*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                setInitDrawerVisible(true);
              },
              children: "Mot de passe oubli\xE9 ?"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h4", {
              children: "Pas encore inscrit ?"
            }), /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: showChildrenDrawer,
              children: /*#__PURE__*/_jsx("b", {
                children: "CREER UN COMPTE ICI"
              })
            })]
          }), /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 4,
              offset: 3
            },
            md: {
              span: 4,
              offset: 3
            },
            children: /*#__PURE__*/_jsxs("div", {
              style: {
                height: '500px',
                alignItems: 'center',
                justifyContent: 'center'
              },
              children: [/*#__PURE__*/_jsx("img", {
                src: "drawables/nl1_rm.png",
                style: {
                  width: '100%'
                }
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("p", {
                style: {
                  fontSize: '19px',
                  fontWeight: 'bold'
                },
                children: ["Utitliser ", /*#__PURE__*/_jsx("b", {
                  children: "Naatou"
                }), " pour g\xE9rer l'acc\xE8s \xE0 vos \xE9venements avec s\xE9curit\xE9 et payer l'acc\xE8s aux \xE9venements en restant sur place."]
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: "Cr\xE9er un compte",
        width: "96%",
        closable: true,
        onClose: onChildrenDrawerClose,
        visible: childrenDraweVisible,
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 4,
              md: 5,
              sm: 12,
              children: registered ? /*#__PURE__*/_jsx(MobileConfirmForm, {
                mobile: newMobile,
                fname: newFn
              }) : /*#__PURE__*/_jsx(UserRegister, {
                handleRegister: handleRegister
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: {
                span: 4,
                offset: 3
              },
              md: {
                span: 4,
                offset: 3
              },
              children: /*#__PURE__*/_jsxs("div", {
                style: {
                  height: '500px',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                children: [/*#__PURE__*/_jsx("img", {
                  src: "drawables/nl1_rm.png",
                  style: {
                    width: '100%'
                  }
                }), /*#__PURE__*/_jsx("p", {
                  style: {
                    fontSize: '17px',
                    fontWeight: 'bold'
                  },
                  children: "Inscrivez-vous et accedez \xE0 un nouveau monde d'\xE9venements !  Votre monde ..."
                })]
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: "Mot de passe oubli\xE9 ?",
        width: 320,
        closable: true,
        onClose: function onClose() {
          return setInitDrawerVisible(false);
        },
        visible: initDrawerVisible,
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(InitPasswordReset, {})
        })
      })]
    })
  });
};
export default UserConnectDrawer;